var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[(_vm.tableData)?_c('EvacuationTable',{attrs:{"evacuationid":_vm.evacuationid,"tabledata":_vm.tableData}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }